<p i18n="@@input-phone-countryworks!">input-phone-country works!</p>
